import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { featureUsersManagerKey, createUsersManagerReducer } from './users-manager.reducer';
import { EffectsModule } from '@ngrx/effects';
import { UsersManagerEffects } from './users-manager.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(featureUsersManagerKey, createUsersManagerReducer),
    EffectsModule.forFeature([ UsersManagerEffects ])
  ]
})
export class UsersManagerStateModule {}